export default __webpack_public_path__ + "static/media/Banks Tightening Creates Opportunities for Non-Banks.252667c9.pdf";